export enum ProductCategoryEnum {
  TIRES = 1,
  // FLUITS = 2,
  // BATERIES = 3,
  GENERAL = 5
}

